import { action } from 'typesafe-actions';
import { BatchRequested, BatchToRequest } from '../../../model/batch';
import { GiroWebappError } from '../../../model/error';
import { BatchRequestActionTypes } from './types';

export const requestBatchRequest = (request: BatchToRequest) => action(BatchRequestActionTypes.REQUEST_BATCH_REQUEST, request);
export const requestBatchSuccess = (batch: BatchRequested) => action(BatchRequestActionTypes.REQUEST_BATCH_SUCCESS, batch);
export const requestBatchError = (error: GiroWebappError) => action(BatchRequestActionTypes.REQUEST_BATCH_ERROR, error);
export const requestBatchResetState = () => action(BatchRequestActionTypes.REQUEST_BATCH_RESET_STATE);
